<template>
  <Enterprises />
</template>

<script setup>
import Enterprises from "~/components/enterprises/index.vue";
</script>
